require('./myProfileKeysTppsDetailKeyView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');
const PropTypes = require('prop-types');

// @ commons
import { ContentBox } from 'commonsComponents/contentBox';
import { CommercialAds } from 'components/commons/commercialAds/commercialAds';
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');

//@components
const TppKeyDetailsInfo = require('components/myProfile/tppKeysComponents/tppKeyDetailsInfo/tppKeyDetailsInfo');
const TppKeyConsentHistory = require('components/myProfile/tppKeysComponents/tppKeyConsentHistory/tppKeyConsentHistory');
const TppKeyError = require('components/myProfile/tppKeysComponents/tppKeyError/tppKeyError');

//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getTppTypeKey } = require('utilities/tpps/tppKeysHelper');

//@actions
const myProfileKeysTppsActions = require('actions/myProfileKeysTpps/myProfileKeysTpps');

//@constants
const { DATE_FORMAT_ES, TPP_RECURRENT_TYPE } = require('constants/index');
const {
    CONSENT_STATUS_VALID,
    CONSENT_STATUS_RECEIVED,
    CONSENT_STATUS_REJECTED,
    CONSENT_STATUS_EXPIRED,
    CONSENT_STATUS_REVOKEDBYPSU,
    CONSENT_STATUS_TERMINATEDBYTPP,
    CONSENT_STATUS_VALIDATED
} = require('constants/tpps');

class MyProfileKeysTppsDetailKeyView extends React.Component {
    componentDidMount = () => {
        const {
            getTppKeyConsents,
            match: { params: {tppId} }
        } = this.props;
        getTppKeyConsents(tppId);
    }

    /*componentWillUnmount () {
        this.props.resetTppKey();
    }*/

    renderButtonOptions = () => {
        return (
            <OKButton
                modifier="ghost"
                inverse={true}
                rightIcon="icon-dropdown-abrir"
                smallRightIcon={true}
            >
                <FormattedText value="keysTppView-moreOptions"/>
            </OKButton>
        )
    }

    buildConsentRecurrentType = (consentRecurringIndicator) => {
        if(typeof consentRecurringIndicator === 'undefined') return '-';
        const recurrentType = consentRecurringIndicator === TPP_RECURRENT_TYPE
            ? <FormattedText value="keysTppView-consentRecurrent" />
            : <FormattedText value="keysTppView-consentNotRecurrent" />
        ;
        return recurrentType;
    }

    buildConsentState = (consentState) => {
        var status;
        switch(consentState){
            case CONSENT_STATUS_VALID:
            case CONSENT_STATUS_VALIDATED: status = <FormattedText value="keysTppView-consentStatusValid" />; break;
            case CONSENT_STATUS_RECEIVED:  status = <FormattedText value="keysTppView-consentStatusReceived" />; break;
            case CONSENT_STATUS_REJECTED: status = <FormattedText value="keysTppView-consentStatusRejected" />; break;
            case CONSENT_STATUS_EXPIRED: status = <FormattedText value="keysTppView-consentStatusExpired" />; break;
            case CONSENT_STATUS_REVOKEDBYPSU: status = <FormattedText value="keysTppView-consentStatusRevokedByPsu" />; break;
            case CONSENT_STATUS_TERMINATEDBYTPP: status = <FormattedText value="keysTppView-consentStatusTerminatedByTpp" />; break;
            default: status = '-';
        }
        return status;
    }

    buildContentDetails = (emptyConsents = false) => {
        const { immAccounts, immProfileKeysTpps, match: { params: {tppId} }, resetTppKey } = this.props;
        const immAccountsById = immAccounts.get('byId');
        const tpp =  immProfileKeysTpps.getIn(['tpps', tppId]);
        const name = tpp.get('name');
        const tppTypeText = getTppTypeKey(tpp);
        const creationDate = tpp.get('creationDate');
        const activationDate = !creationDate ? '-' : moment(creationDate).format(DATE_FORMAT_ES);
        let consentStatus = '-';
        let consentRecurringIndicator = '-';
        let products = null;
        if (!emptyConsents) {
            const consent = immProfileKeysTpps.getIn(['tpps', tppId, 'consent'], );
            consentStatus = this.buildConsentState(consent.get('consentStatus').toLowerCase());
            consentRecurringIndicator = this.buildConsentRecurrentType(consent.get('recurrentType'));
            products = consent.get('products') || null;
        }
        const allConsents = immProfileKeysTpps.getIn(['allConsents', 'consents']);

        return (
            <div className="tpp-key-detail-view__body">
                <div className="row">

                    <div className="col-xs-12 col-md-8">
                        <TppKeyDetailsInfo
                            tppId={tppId}
                            immTpp={tpp}
                            immAccounts={immAccountsById}
                            immProfileKeysTpps={immProfileKeysTpps}
                            resetTppKey={resetTppKey}
                            products={products}
                            consentState={consentStatus}
                            consentRecurringIndicator={consentRecurringIndicator} />
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            <div className="col-xs-12 grid-view--variable-cell-separation">
                                <ContentBox>
                                    <div className="tpp-key-detail-info__title">
                                        <FormattedText value="keysTppView-tppInfo" />
                                    </div>
                                    <div className="tpp-key-detail-info__separator"></div>
                                    <div className="">
                                        <div className="tpp-key-detail-view__content-item">
                                            <div className="tpp-key-detail-view__content-label">
                                                <FormattedText value="keysTppView-nameAliasTPP" />
                                            </div>
                                            <div className="tpp-key-detail-view__content-value">{name}</div>
                                        </div>
                                        <div className="tpp-key-detail-view__content-item">
                                            <div className="tpp-key-detail-view__content-label">
                                                <FormattedText value="keysTppView-typeTPP" />
                                            </div>
                                            {tppTypeText && <FormattedText value={tppTypeText}/>}
                                        </div>
                                        <div className="tpp-key-detail-view__content-item">
                                            <div className="tpp-key-detail-view__content-label">
                                                <FormattedText value="keysTppView-activationDate" />
                                            </div>
                                            <div className="tpp-key-detail-view__content-value"> {activationDate} </div>
                                        </div>
                                    </div>
                                </ContentBox>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-8">
                        <TppKeyConsentHistory allConsents={allConsents} />
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="tpp-key-detail-view__banner row">
                            <div className="col-xs-12 grid-view--variable-cell-separation">
                                <CommercialAds path="global" type="banner-a" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            )
    }

    handleRetry = () => {
        this.props.history.push('/myprofile/keys/tpps');
    }

    render() {
        const {
            immProfileKeysTpps,
            match: { params: {tppId} }
        } = this.props;
        const tpp =  immProfileKeysTpps.getIn(['tpps', tppId]);
        const loadingComponent = (
            <div className="tpp-key-detail-view__loading">
                <LoadingSection />
            </div>
        )

        if (tpp) {
            const consentId =  tpp.get('consent') && tpp.get('consent').get('consentId');
            const title = <FormattedText value="keysTppView-detailsTitle" injectedStrings={[tpp.get('name')]}/>;
            const urlRemove = `/myprofile/keys/tpps/removeTppConsent/${tppId}/${consentId}`;
            let content;
            if (!immProfileKeysTpps.get('isFetchingConsents') && tpp.get('consent')) {
                content = this.buildContentDetails()
            } else if (!immProfileKeysTpps.get('isFetchingConsents') && tpp.get('hasEmptyConsents')){
                content = this.buildContentDetails(true)
            } else if (immProfileKeysTpps.get('isErrorRequest')) {
                const title = <FormattedText value="keysTppView-removeTppKeyError"/>;
                content = <TppKeyError title={title} onRetry={this.handleRetry} />
            } else {
                content = loadingComponent
            }

            const mappingBreadcrumb = [
                ...(!__CONTACT_CENTER__ ? [
                    {
                        text: formatText('profileKeysLanding-title'),
                        url: '/myprofile/keys'
                    }
                ] : []),
                {
                    text: formatText('profileKeysLanding-changeTPP'),
                    url: '/myProfile/keys/tpps'
                },
                {
                    text: title,
                    url: ''
                }
            ];

            const deleteLinkButton = (
                <div className="my-profile-keys-tpps-view__header-delete-link-btn">
                    <OKButton
                        modifier="primary"
                        to={urlRemove}
                        disabled={!consentId}
                    >
                        <FormattedText value="removeConsentTppView-removeConsentTppTitle"/>
                    </OKButton>
                </div>
            );

            return (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="large" section="accounts" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={title}
                                />
                                {deleteLinkButton}
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            {content}
                        </div>
                    </div>
                </div>
            );
        } else {
            return loadingComponent
        }
    }
}


MyProfileKeysTppsDetailKeyView.propTypes = {
    getTppKeyConsents: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfileKeysTpps: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resetTppKey: PropTypes.func.isRequired
}

module.exports.constructor = MyProfileKeysTppsDetailKeyView;
module.exports.MyProfileKeysTppsDetailKeyView = connect(
    state => ({
        immAccounts: state.accounts,
        immProfileKeysTpps: state.myProfileKeysTpps,
    }), {
        getTppKeyConsents: myProfileKeysTppsActions.getTppKeyConsents,
        resetTppKey: myProfileKeysTppsActions.resetTppKey,
    }
)(MyProfileKeysTppsDetailKeyView);
